import { FC } from 'react';
import { PageItem } from '../types/PageItem';
import { getItemConfig } from '../utils/getItemConfig';

export type PaginationItemProps = {
  item: PageItem;
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void; // eslint-disable-line
};

const PaginationItem: FC<PaginationItemProps> = (props) => {
  const config = getItemConfig(props);
  if (!config) return null;

  const { disabled, active, className, content, onClick } = config;

  return (
    <li
      className={`page-item ${active ? 'active' : ''} ${
        disabled ? 'disabled' : ''
      }`}
    >
      {onClick ? (
        <button
          type="button"
          className={`page-link ${className ?? ''}`}
          disabled={disabled}
          onClick={onClick}
        >
          {content}
        </button>
      ) : (
        <span className={`page-link ${className ?? ''}`}>{content}</span>
      )}
    </li>
  );
};

export default PaginationItem;
